var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowMore = function SvgArrowMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M.851.842a1.224 1.224 0 0 1 1.698 0L6.5 4.683 10.451.842a1.224 1.224 0 0 1 1.697 0 1.144 1.144 0 0 1 0 1.65l-4.8 4.666c-.225.22-.53.342-.848.342-.318 0-.623-.123-.849-.342l-4.8-4.666a1.144 1.144 0 0 1 0-1.65Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowMore;